import { render, staticRenderFns } from "./RoomView.vue?vue&type=template&id=6ad3c81b&scoped=true&"
import script from "./RoomView.vue?vue&type=script&lang=ts&"
export * from "./RoomView.vue?vue&type=script&lang=ts&"
import style0 from "./RoomView.vue?vue&type=style&index=0&id=6ad3c81b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad3c81b",
  null
  
)

export default component.exports